import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { MultiCrudDataSource } from '../../table-datasouces/multi-crud.datasource';
import { Product } from '../../dto/product';
import { ProductService } from '../services/product.service';
import { RoleService } from '../../services/role.service';
import {Newsletter} from '../../dto/newsletter';
import {AppMatCustomAction} from '../../shared/mat-table-generator/mat-table-core/app-mat-custom-action';
import {TrustPayTransaction} from '../../dto/trustPayTransaction';
import {ConfirmDialogComponent} from '../../shared/confirm-dialog/confirm-dialog.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private roleService: RoleService,
    private router: Router,
    private datePipe: DatePipe,
    public productService: ProductService,
    private dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.isLoading = true;
        this.productService.getActiveCardsCount().subscribe(value => {
          this.sumActiveCards = value;
          this.isLoading = false;
        }, error => {
          this.isLoading = false;
        });
    }

  sumActiveCards: number = 0;
  isLoading: boolean = false;

  dataSource = new MultiCrudDataSource(this.productService);
  columns = [

    { columnDef: 'id', header: 'ID', cellColor: (row: Product) => row.replacementProductId != null ? 'dimgrey' : 'black', cell: (row: Product) => row.id },

    { columnDef: 'productKey', header: 'Key', cellColor: (row: Product) => row.replacementProductId != null ? 'dimgrey' : 'black', cell: (row: Product) => row.productKey },


    { columnDef: 'primaryProduct', header: 'Primary', cell: (row: Product) => {
      if ( row.primaryProductId != null ) {
        return row.primaryProduct?.internalName;
      }
        return '';
      } },

    { icon: (row: Product) => {
        if ( !row.canOrderAsPrimary ) {
          return false;
        }
        return 'done';
      },
      cellColor: (row: Product) => {
        if ( !row.canOrderAsPrimary ) {
          return 'orange';
        }
        return '#8bc34a';
      }, columnDef: 'canOrderAsPrimary', header: 'Primary', cell: (row: Product) => '',
    },

    { icon: (row: Product) => {
        if ( !row.active ) {
          return 'close';
        }
        if ( row.replacementProductId != null ) {
          return 'autorenew';
        }
        return false;
      },
      cellColor: (row: Product) => {
        if ( !row.active ) {
          return 'red';
        }
        if ( row.replacementProductId != null ) {
          return 'orange';
        }
        return '#8bc34a';
      }, columnDef: 'active', header: 'Active', cell: (row: Product) => false
    },

    { columnDef: 'internalName', header: 'Internal Name', cellColor: (row: Product) => row.replacementProductId != null ? 'dimgrey' : 'black', cell: (row: Product) => {
        if ( row.replacementProductId != null ) {
          return row.internalName + ' (REPLACED)';
        }
        return row.internalName;
      } },
    { columnDef: 'companyId', header: 'Company', cellColor: (row: Product) => row.replacementProductId != null ? 'dimgrey' : 'black', cell: (row: Product) => `${row.companyName}` },
    { columnDef: 'issuingFee', header: 'Issuing Fee', cellColor: (row: Product) => row.replacementProductId != null ? 'dimgrey' : 'black', cell: (row: Product) => `${row.issuingFee.formatMoneyEuro()}`, class: 'text-right' },
    { columnDef: 'annualFee', header: 'Annual Fee', cellColor: (row: Product) => row.replacementProductId != null ? 'dimgrey' : 'black', cell: (row: Product) =>  row.annualFee == row.annualFeeFromSecondYear ? `${row.annualFee.formatMoneyEuro()}` : `${row.annualFee.formatMoneyEuro()} / ${row.annualFeeFromSecondYear.formatMoneyEuro()}`, class: 'text-right' },
    { columnDef: 'productRef', header: 'Product ref', cellColor: (row: Product) => row.replacementProductId != null ? 'dimgrey' : 'black', cell: (row: Product) => `${row.productRef}`, class: 'text-right' },
    { columnDef: 'cardsCount', header: 'Cards', cellColor: (row: Product) => row.replacementProductId != null ? 'dimgrey' : 'black', cell: (row: Product) => `${row.cardsCount.formatThousands()}`, class: 'text-right' },
    { columnDef: 'activeCardsCount', header: 'Active Cards', cellColor: (row: Product) => row.replacementProductId != null ? 'dimgrey' : 'black', cell: (row: Product) => `${row.activeCardsCount.formatThousands()}`, class: 'text-right' },
    { columnDef: 'activePseudoCardsCount', header: 'Pseudo Cards', cellColor: (row: Product) => row.replacementProductId != null ? 'dimgrey' : 'black', cell: (row: Product) => `${row.activePseudoCardsCount.formatThousands()}`, class: 'text-right' },

  ];

  public productCustomActions: AppMatCustomAction[] = [
    new AppMatCustomAction('content_copy', 'Copy template', false, (row: Product) => {
      this.dialog.open(ConfirmDialogComponent, {
        data: {
          title: 'Copy product',
          text: 'Are you sure you want to copy the product?'
        },
        minWidth: 350,
      })
        .afterClosed()
        .subscribe(result => {
          if (result == 'ok') {
            this.copyProduct(row.id);
          }
        });
    }),
  ];

  getViewLink = (item: Product): string => item.id.toString();

  getEditLink = (item: Product): string => item.id.toString() + '/edit';

  deleteEnabled() {
    return this.roleService.hasRoles( 'admin' );
  }

  copyProduct(id: number) {
    this.productService.copy(id).subscribe(newProduct => {
      this.router.navigate([newProduct.id], {relativeTo: this.route});
    });
  }


}


